<template>
    <footer class="footer" :class="{ [`footer-${type}`]: type }" :data-background-color="backgroundColor">
        <div class="container">
            <nav>
                <ul>
                    <li>
                        <div class="footer-info-block">
                            <a href="https://www.hakka.gov.tw/indexwww.html" rel="noopener noreferrer" target="_blank">
                                中華民國客家委員會
                            </a>
                        </div>

                        <div class="footer-info-block">
                            地址：24220 新北市新莊區中平路439號北棟17樓
                        </div>

                        <div class="footer-info-block">
                            電話：(02)8995-6988　傳真：(02)8995-6987
                        </div>
                    </li>
                    <!-- <li>
                        <a href="https://www.beehivedt.com/" rel="noopener noreferrer" target="_blank">
                            蜂巢數據科技 Beehive Data Technology
                        </a>
                    </li> -->
                </ul>
            </nav>
            <div class="copyright">
                &copy; {{ year }}
                <!-- <a href="https://www.agriweather.online" rel="noopener noreferrer" target="_blank" alt="AgriWeather">AgriWeather</a>,
                <a href="https://www.beehivedt.com/" rel="noopener noreferrer" target="_blank" alt="AgriWeather">Beehive Data Technology Co., Ltd.</a>
                All Rights Reserved. -->
                中華民國客家委員會 著作權所有
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        props: {
            backgroundColor: String,
            type: String
        },
        data() {
            return {
                year: new Date().getFullYear()
            };
        }
    };
</script>

<style lang="scss" scoped>

a {
    &:hover, &:active, &:focus {
        color: #8fb675 !important;
        text-decoration: none;
    }
}

li
{
    vertical-align: top;
}

.footer-info-block
{
    display: inline-block;
    margin-right: 15px;
}

</style>
